import axios from "axios";

// ✅ Use environment variable or fallback to localhost
const API_BASE =
  process.env.REACT_APP_API_BASE || "http://localhost:8000";

// ✅ Create Axios instance
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // send cookies (important for auth)
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Optional: attach token automatically if you use JWT
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // or from cookies
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ✅ Optional: log requests in dev mode
if (process.env.REACT_APP_DEBUG === "true") {
  api.interceptors.response.use(
    (response) => {
      console.log("✅ API Response:", response);
      return response;
    },
    (error) => {
      console.error("❌ API Error:", error.response || error);
      return Promise.reject(error);
    }
  );
}

export default api;
